import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { ActivityStatus, SubmissionStatus } from '../../../components';
import LikedByPopup from '../../../features/collection/components/liked-by-popup';
import { RejectionPopup } from '../../../features/collection/components/rejection-popup';
import { useInternationalization } from '../../../features/i18n';

const SidebarStatus = ({isEdit}) => {
  const { needRevisionId } = useSelector(state => state.system)
  const form = useSelector(state => state.eventForm.data)
  const [showLikedBy, setShowLikedBy] = useState(false)
  const [showBookmarkedBy, setShowBookmarkedBy] = useState(false)
  const {
    likes,
    bookmarks,
    total_likes,
    total_bookmarks,
    status_id
  } = useSelector(state => state.event.data)
  const {
    submission_status_id,
    reason,
  } = form
  const [rejectionPopedUp, setRejectionPopedUp] = useState(false)
  const { translate, language } = useInternationalization()

  const showReasonTrigger = submission_status_id === needRevisionId

  return <>
    {
      isEdit && <>
      <div className="mb-5">
        <p className="text-sm text-gray-444">
          Status: <strong><SubmissionStatus value={submission_status_id}/></strong>
        </p>
        {
          showReasonTrigger &&
          <p className="link mb-5" onClick={() => setRejectionPopedUp(true)}>
            {translate('GENERAL', 'what_to_fix')}
          </p>
        }
        <p className="text-sm text-gray-444">
          {translate('LIKE', 'liked_by')}: <strong onClick={() => setShowLikedBy(true)} className="underline cursor-pointer">
            {total_likes}
          </strong>
        </p>
        <p className="text-sm text-gray-444">
          {translate('BOOKMARK', 'bookmarked_by')}: <strong onClick={() => setShowBookmarkedBy(true)} className="underline cursor-pointer">
            {total_bookmarks}
          </strong>
        </p>
      </div>
      <p className="text-sm text-gray-444 mb-5">
        {language.name === 'en' ? 'Event Status' : 'Status Acara'}: <ActivityStatus value={status_id}/>
      </p>
      </>
    }
    {
      rejectionPopedUp &&
      <RejectionPopup onClose={setRejectionPopedUp} content={reason}/>
    }
    {
      showLikedBy &&
      <LikedByPopup onClose={() => setShowLikedBy(false)} data={likes}/>
    }
    {
      showBookmarkedBy &&
      <LikedByPopup
        onClose={() => setShowBookmarkedBy(false)}
        data={bookmarks}
        title={`${translate('BOOKMARK', 'bookmarked_by')}: ${total_bookmarks} User(s)`}
      />
    }
  </>
}

export { SidebarStatus }
